<template>
  <div class="count-down" v-if="countDown.total > 0">
    <span>{{$t('countDown')}}</span>
    <ul>
      <li>{{countDown.days}} :</li>
      <li>{{countDown.hours}} :</li>
      <li>{{countDown.minutes}} :</li>
      <li>{{countDown.seconds}}</li>
    </ul>
  </div>
</template>

<script>
import locales from './lang';

export default {
  props: ['endTime'],
  locales,
  data() {
    return {
      countDown: {
        total: '',
        days: '',
        hours: '',
        minutes: '',
        seconds: ''
      }
    };
  },
  mounted() {
    this.getCountDown(this.endTime);
  },
  methods: {
    countDownFunc(endTime) {
      const nowTime = new Date();
      const endTime1 = new Date(endTime);
      let times = (endTime1 - nowTime) / 1000;

      let days = 0;
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
      days = Math.floor(times / 60 / 60 / 24) + '';
      hours = Math.floor((times / 60 / 60) % 24) + '';
      minutes = Math.floor((times / 60) % 60) + '';
      seconds = Math.floor(times % 60);

      if (days <= 9) {
        days = '0' + days;
      }
      if (hours <= 9) {
        hours = '0' + hours;
      }
      if (minutes <= 9) {
        minutes = '0' + minutes;
      }
      if (seconds <= 9) {
        seconds = '0' + seconds;
      }
      this.countDown = {
        total: times,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      };
      this.$emit('timer', this.total);
    },
    getCountDown(endTime) {
      let timer = setInterval(() => {
        this.countDownFunc(endTime);
        if (this.countDown.total <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
.count-down {
  position: absolute;
  bottom: 0.15rem;
  @media (width: 768px) {
    bottom: 0.24rem;
  }
  @media (max-width: 767px) {
    bottom: -0.3rem;
  }
  left: 50%;
  transform: translateX(-50%);
  width: 2.3rem;
  height: 0.24rem;
  line-height: 0.24rem;
  text-align: center;
  color: #fff;
  border-radius: 0 0 6px 6px;
  //background-image: url("../../../../static/img/dashboard/activity/count-down.svg");
  background-size: cover;
  background-repeat: no-repeat;
  span {
    font-size: 0.14rem;
    line-height: 0.14rem;
    margin-right: 0.1rem;
  }
  ul {
    display: inline-block;
    padding: 0;
    li {
      width: 21px;
      list-style: none;
      display: inline-block;
      font-size: 0.12rem;
      line-height: 0.12rem;
    }
  }
}

@media screen and (max-width: 769px) {
  .count-down {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// countDown.vue?6e1e96e0